export default __webpack_public_path__ + "static/media/hbs-k-blk-2.b2dbfe21.png";